import { CUSTOMER_API_URL } from '@/api/ProfileApi'
import { SecureTransactionType } from '@/domains/SecureConfirmDomain'
import { ICallBrowser } from '@/utils/bridgeUtils/features/callBrowser'
import { IChangeDebitCardPincodeParams } from '@/utils/bridgeUtils/features/changeDebitCardPincode'
import { IChangeStatusBarParams } from '@/utils/bridgeUtils/features/changeStatusBar'
import { IFinGetLineInfoResult } from '@/utils/bridgeUtils/features/finGetLineInfo'
import { IAddressInfoResult, IRequestAddressInfo } from '@/utils/bridgeUtils/features/getAddress'
import { IBankInfoResult } from '@/utils/bridgeUtils/features/getBank'
import { IContactRequestParams, IContactResult } from '@/utils/bridgeUtils/features/getContact'
import { IAccountInfoResult } from '@/utils/bridgeUtils/features/getMyAccount'
import { INativeInfoResult } from '@/utils/bridgeUtils/features/getNativeInfo'
import { IWithdrawalAccountParams } from '@/utils/bridgeUtils/features/getWithdrawalAccount'
import { IYearMonthInfoResult, IYearMonthParams } from '@/utils/bridgeUtils/features/getYearMonth'
import { INavigateParams } from '@/utils/bridgeUtils/features/navigateTo'
import {
  INotiResponseExposedTimeReadParams,
  INotiResponseExposedTimeResult,
  INotiResponseExposedTimeWriteParams,
  NotiResponseExposedTimeTASK,
} from '@/utils/bridgeUtils/features/notificationExposedTime'
import { IOnBackPressedParams } from '@/utils/bridgeUtils/features/onBackPressed'
import { IRequestAuthResult } from '@/utils/bridgeUtils/features/requestAuth'
import {
  HostType,
  IRequestPinAuthResult,
  PinClass,
  PinCodeName,
  PinType,
} from '@/utils/bridgeUtils/features/requestPinAuth'
import { IDataParams } from '@/utils/bridgeUtils/features/sendData'
import { ILogEventParams } from '@/utils/bridgeUtils/features/sendLogEvent'
import { ISetDebitCardPincodeResult } from '@/utils/bridgeUtils/features/setDebitCardPincode'
import { IContentParams } from '@/utils/bridgeUtils/features/shareContent'
import { INotiResponseParams } from '@/utils/bridgeUtils/features/showNotification'
import { IVibrateParams } from '@/utils/bridgeUtils/features/vibrate'
import { $ } from '@/utils/i18nUtils'

export const finGetLineInfo = (): Promise<IFinGetLineInfoResult> => {
  return (window as any).idvu.finGetLineInfo()
}

export const callBrowser = (data: ICallBrowser) => {
  ; (window as any).idvu.callBrowser(data)
}

export const getNativeInfo = (): Promise<INativeInfoResult> => {
  return (window as any).idvu.getNativeInfo()
}

export const vibrate = (data: IVibrateParams) => {
  ; (window as any).idvu.vibrate(data)
}

export const showNotification = (data: INotiResponseParams) => {
  ; (window as any).idvu.showNotification(data)
}

export const shareContent = (data: IContentParams) => {
  ; (window as any).idvu.shareContent(data)
}

export const sendData = (data: IDataParams) => {
  ; (window as any).idvu.sendData(data)
}

export const getBank = (): Promise<IBankInfoResult> => {
  return (window as any).idvu.getBank()
}

export const getContact = (data?: IContactRequestParams): Promise<IContactResult> => {
  return (window as any).idvu.getContact(data)
}

export const getMyAccount = (): Promise<IAccountInfoResult> => {
  return (window as any).idvu.getMyAccount()
}

export const getAddress = (data: IRequestAddressInfo): Promise<IAddressInfoResult> => {
  return (window as any).idvu.getAddress(data)
}

export const navigateTo = (scheme: string, isClose = true) => {
  ; (window as any).idvu.navigateTo({ scheme, isClose } as INavigateParams)
}

export const changeStatusBar = (data: IChangeStatusBarParams) => {
  ; (window as any).idvu.changeStatusBar(data)
}

export const getWithdrawalAccount = (
  data: IWithdrawalAccountParams,
): Promise<IAccountInfoResult> => {
  return (window as any).idvu.getWithdrawalAccount(data)
}

export const getYearMonth = (data: IYearMonthParams): Promise<IYearMonthInfoResult> => {
  return (window as any).idvu.getYearMonth(data)
}

export const onBackPressed = (data: IOnBackPressedParams) => {
  ; (window as any).idvu.onBackPressed(data)
}
export const closeWebView = () => {
  ; (window as any).idvu.closeWebView()
}

export const sendLogEvent = (data: ILogEventParams) => {
  ; (window as any).idvu.sendLogEvent(data)
}

export const sendMoeLogEvent = (data: ILogEventParams) => {
  ; (window as any).idvu.sendMoeLogEvent(data)
}

export const notificationExposedTime = (
  data: INotiResponseExposedTimeWriteParams | INotiResponseExposedTimeReadParams,
): Promise<INotiResponseExposedTimeResult> | undefined => {
  if (data.task === NotiResponseExposedTimeTASK.READ) {
    return (window as any).idvu.notificationExposedTime(data)
  }

  ; (window as any).idvu.notificationExposedTime(data)

  return
}

export const callCenter = () => {
  ; (window as any).idvu.callCenter()
}

interface IEnterTransactionPinForDebitCard {
  hostType: HostType
  apiUrl: string
  request: { [key: string]: any }
}

export const enterTransactionPinForDebitCard = (
  data: IEnterTransactionPinForDebitCard,
): Promise<IRequestPinAuthResult> => {
  const { hostType, apiUrl, request } = data
  const params = {
    pinType: PinType.HALF,
    pinClass: PinClass.TRANSFER,
    title: $('pin_transaction_title'),
    description: '',
    hostType,
    apiUrl,
    pinCodeName: PinCodeName.TR_PIN_NO,
    request: JSON.stringify(request),
  }

  return (window as any).idvu.requestPinAuth(params)
}

export interface ISecureConfirmation {
  secureTransaction: SecureTransactionType
  title: string
  content: string
  locale: string
}

interface IRequestParamsForTransfer {
  secureConfirmation: ISecureConfirmation
}

export interface IEnterTransactionPinForTransfer {
  hostType: HostType
  apiUrl: string
  version?: string
  request: IRequestParamsForTransfer & { [key: string]: any }
}

export const enterTransactionPinForTransfer = (
  data: IEnterTransactionPinForTransfer,
): Promise<IRequestPinAuthResult> => {
  const { hostType, apiUrl, request } = data
  const params = {
    pinType: PinType.HALF,
    pinClass: PinClass.TRANSFER,
    title: $('pin_transaction_title'),
    description: '',
    hostType,
    apiUrl,
    pinCodeName: PinCodeName.TR_PIN_NO,
    request: JSON.stringify(request),
  }

  return (window as any).idvu.requestPinAuth(params)
}

export const enterTransactionPinForTransferBeta = (
  data: IEnterTransactionPinForTransfer,
): Promise<IRequestPinAuthResult> => {
  const { hostType, apiUrl, request } = data

  const params = {
    pinType: PinType.HALF,
    pinClass: PinClass.TRANSFER,
    title: $('pin_transaction_title'),
    description: '',
    hostType,
    apiUrl,
    version: 'v2',
    pinCodeName: PinCodeName.TR_PIN_NO,
    request: JSON.stringify(request),
  }

  return (window as any).idvu.requestPinAuth(params)
}

interface IRequestAuth {
  hostType: HostType
  apiUrl: string
  request: { [key: string]: any }
}

export const requestAuth = (data: IRequestAuth): Promise<IRequestAuthResult> => {
  const { hostType, apiUrl, request } = data
  const params = {
    hostType,
    apiUrl,
    request: JSON.stringify(request),
  }

  return (window as any).idvu.requestAuth(params)
}

export const setDebitCardPin = (): Promise<ISetDebitCardPincodeResult> => {
  const params = {
    hostType: HostType.CUSTOMER_API,
    confirmApiUrl: CUSTOMER_API_URL.DEBIT_CARD_PINCODE_COMPARE,
    request: JSON.stringify({}),
  }

  return (window as any).idvu.setDebitCardPincode(params)
}

export const changeDebitCardPin = (
  data: IChangeDebitCardPincodeParams,
): Promise<ISetDebitCardPincodeResult> => {
  return (window as any).idvu.changeDebitCardPincode(data)
}

export const requestRefreshAuth = () => {
  ; (window as any).idvu.requestRefreshAuth()
}
